import React from "react";
import Block from "../Block";

class DefaultBlock extends Block {
  render() {
    const { context, block } = this.props;

    if (block.name == 'eedee/block-gutenslider')
      return null

    console.error(`[CATCHED] BLOCK WITH NO RENDERER ${block.name}`, context.link || context.uri)
    return null;
  }
}

class DefaultBlockFactory {
  get type() {
    return "default";
  }

  create(props) {
    return <DefaultBlock {...props} />;
  }
}

export default DefaultBlockFactory;
